import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import img from "../../assets/images/login_logo.png";
import { loginUser } from "../../store/slices/authSlice";
import { RootDispatch, RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import { Eye, EyeOff } from "lucide-react";
import Button from "../../components/Assets/Button";
import { ButtonType } from "../../assets/Button";

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch: RootDispatch = useDispatch();
  const loading = useSelector((state: RootState) => state.auth.loading);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email && !password) {
      return toast.error("email and Password are required");
    }
    if (!email) {
      return toast.error("email is required");
    }
    if (!password) {
      return toast.error("Password is required");
    }
    try {
      await dispatch(loginUser({ email, username, password })).unwrap();

      navigate("/", { replace: true });
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen w-full px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="bg-white rounded-2xl overflow-hidden w-full max-w-xl shadow-md relative">
        <div className="p-6 sm:p-8 md:p-10 flex items-center justify-center h-full">
          <div className="w-full flex flex-col items-center space-y-6">
            {/* Logo */}
            {!loading && (
              <img
                src={img}
                alt="Logo"
                className="w-48 h-28 mb-6 object-contain"
              />
            )}

            {loading ? (
              <Skeleton height={50} width={200} className="mb-4" />
            ) : (
              <h2 className="text-4xl font-extrabold text-gray-900 mb-4 text-center">
                Welcome Back!
              </h2>
            )}

            <div className="flex items-center mb-8">
              {loading ? (
                <Skeleton height={24} width={24} className="mr-2" />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
              {loading ? (
                <Skeleton height={16} width={150} />
              ) : (
                <p className="text-sm text-gray-600">
                  Log in to access your dashboard
                </p>
              )}
            </div>

            {loading ? (
              <Skeleton height={40} className="mb-4" />
            ) : (
              <form className="space-y-6 w-full">
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full p-4 bg-white/80 border border-gray-300 rounded-lg text-gray-800 placeholder-gray-600 focus:ring-2 focus:ring-blue-400 focus:outline-none transition-all duration-300"
                />
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full p-4 bg-white/80 border border-gray-300 rounded-lg text-gray-800 placeholder-gray-600 focus:ring-2 focus:ring-blue-400 focus:outline-none transition-all duration-300 pr-12"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="absolute right-4 top-4 text-gray-600 hover:text-gray-900"
                  >
                    {showPassword ? <Eye size={24} /> : <EyeOff size={24} />}
                  </button>
                </div>
                <Button
                  type={ButtonType.Submit}
                  onClick={handleLogin}
                  className="w-full"
                >
                  Login
                </Button>
                <Button
                  type={ButtonType.Cancel}
                  onClick={() => navigate("/login-otp")}
                  className="w-full bg-gray-200 text-gray-800 hover:bg-gray-300 text-sm"
                >
                  Channel Partner / Delear Login
                </Button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
